var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralSettingsIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 31,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 31,
    rx: 4.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6591 21.5007C17.0366 20.4326 18.0552 19.6673 19.2526 19.6673C20.45 19.6673 21.4686 20.4326 21.8461 21.5007H31.1693V23.334H21.8461C21.4686 24.4021 20.45 25.1673 19.2526 25.1673C18.0552 25.1673 17.0366 24.4021 16.6591 23.334H12.8359V21.5007H16.6591ZM22.1591 15.084C22.5366 14.0159 23.5553 13.2507 24.7526 13.2507C25.95 13.2507 26.9686 14.0159 27.3461 15.084H31.1693V16.9173H27.3461C26.9686 17.9854 25.95 18.7507 24.7526 18.7507C23.5553 18.7507 22.5366 17.9854 22.1591 16.9173H12.8359V15.084H22.1591ZM16.6591 8.66732C17.0366 7.59923 18.0552 6.83398 19.2526 6.83398C20.45 6.83398 21.4686 7.59923 21.8461 8.66732H31.1693V10.5007H21.8461C21.4686 11.5687 20.45 12.334 19.2526 12.334C18.0552 12.334 17.0366 11.5687 16.6591 10.5007H12.8359V8.66732H16.6591ZM19.2526 10.5007C19.7589 10.5007 20.1693 10.0902 20.1693 9.58398C20.1693 9.07773 19.7589 8.66732 19.2526 8.66732C18.7463 8.66732 18.3359 9.07773 18.3359 9.58398C18.3359 10.0902 18.7463 10.5007 19.2526 10.5007ZM24.7526 16.9173C25.2589 16.9173 25.6693 16.5069 25.6693 16.0007C25.6693 15.4944 25.2589 15.084 24.7526 15.084C24.2463 15.084 23.8359 15.4944 23.8359 16.0007C23.8359 16.5069 24.2463 16.9173 24.7526 16.9173ZM19.2526 23.334C19.7589 23.334 20.1693 22.9236 20.1693 22.4173C20.1693 21.911 19.7589 21.5007 19.2526 21.5007C18.7463 21.5007 18.3359 21.911 18.3359 22.4173C18.3359 22.9236 18.7463 23.334 19.2526 23.334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralSettingsIconV2);
export default __webpack_public_path__ + "static/media/generalSettingsIconV2.7b2c1e14.svg";
export { ForwardRef as ReactComponent };